import * as React from 'react';
import styled from 'styled-components';
import { fontSize, FontSizeProps, LineHeightProps, PaddingProps, padding } from 'styled-system';

import { themeGet, ContentContainer } from '@packages/ui';

const Container = styled.div<PaddingProps>`
  background: ${themeGet.colors('potPourri')};
  text-align: center;
  padding: 30px 68px;
  ${padding}
  ${ContentContainer} {
    display: flex;
    justify-content: center;
  }
`;

Container.defaultProps = {
  px: ['12px', '68px'],
  py: [3, 3, 5, 3],
};

const Text = styled.h2<FontSizeProps & LineHeightProps>`
  flex: 0 1 640px;
  margin: 0;
  padding: 0;
  ${fontSize}
  font-family: ${themeGet.fonts('brandSecondary')};
  color: ${themeGet.colors('primary')};
  font-weight: ${themeGet.fontWeight('normal')};
`;

Text.defaultProps = {
  fontSize: [7, 7, 7, 8],
};

export const Title: React.FC<{ title: string }> = ({ title }) => (
  <Container>
    <ContentContainer>
      <Text>{title}</Text>
    </ContentContainer>
  </Container>
);
